import { Component } from '@angular/core';
import { HttpService } from '../../http.service';
import { GlobalService } from 'src/app/global.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-route-gatepass',
  templateUrl: './route-gatepass.component.html',
  styleUrls: ['./route-gatepass.component.scss']
})
export class RouteGatepassComponent {
  routes = [];
  sessions = [];
  products = [];
  sales: any = {};
  is_sales_data_available = false;
  tray_config = {};

  product_ids = [];
  milk_product_ids = [];
  other_product_ids = [];
  default_date = new Date().toISOString();
  pdf: any = null;

  constructor(private http: HttpService, private global: GlobalService, private sanitizer:DomSanitizer) {
    this.global.set_master_page_title = 'Route Gate Pass';
    this.getRoutes();
    this.getSession();
    this.getProducts();
    this.getTrayConfig();
  }


  getRoutes() {
    this.http.getRouteSessionWise().subscribe((data: []) => {
      console.log(data);
      this.routes = data;
    }, (error) => {
      console.log(error);
    });
  }

  getSession() {
    this.http.getSession().subscribe((data: []) => {
      console.log(data);
      this.sessions = data;
    }, (error) => {
      console.log(error);
    });
  }

  showPdf() {
    const linkSource = 'data:application/pdf;base64,' + this.pdf;
    const downloadLink = document.createElement("a");
    const fileName = "sample.pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

  getGatePass(date, route_id, session_id) {
    // console.log(date);
    // console.log(route_id);
    // console.log(session_id);
    const req_data = {
      'date': date,
      'route_id': route_id,
      'session_id': session_id,
    };
    // this.http.PrepareCanvas(req_data).subscribe((data) => {
    //   console.log(data)
    //   this.pdf = data['pdf']
    // });
    this.http.getRouteGatePass(req_data).subscribe((data) => {
      console.log(data);
      this.sales = data;
      this.is_sales_data_available = true;
      this.product_ids = Object.keys(data['sales']);
      this.milk_product_ids = Object.keys(data['milk']);
      this.other_product_ids = Object.keys(data['other']);
    }, (error) => {
      console.log(error);
      this.sales = {};
      this.is_sales_data_available = false;
    });
  }

  getProducts() {
    this.http.getProductForAgentOrder().toPromise().then((data: []) => {
      console.log(data);
      this.products = data;
    }).catch((error) => {
      console.log(error);
    });
  }

  photoURL() {
    return this.sanitizer.bypassSecurityTrustUrl(this.pdf);
  }

  serveProductCount(product_id) {
    if (this.sales['sales'].hasOwnProperty(product_id)) {
      return this.sales['sales'][product_id]['count'];
    } else {
      return 0;
    }
  }

  getProductTrayCount(product_id) {
    if (this.tray_config.hasOwnProperty(product_id)) {
      if (this.sales['sales'].hasOwnProperty(product_id)) {
        const tray_count = parseInt(String(this.sales['sales'][product_id]['count'] / this.tray_config[product_id][0]['product_count']));
        return tray_count;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  getTrayConfig() {
    this.http.getTrayConfig().toPromise().then((data) => {
      console.log(data);
      this.tray_config = data;
    }, (error) => {
      console.log(error);
    });
  }

  serveProductPocketCount(product_id) {
    if (this.sales['sales'].hasOwnProperty(product_id)) {
      if (this.tray_config.hasOwnProperty(product_id)) {
        const pocket_count = this.sales['sales'][product_id]['count'] % this.tray_config[product_id][0]['product_count'];
        return pocket_count;
      } else {
        return this.sales['sales'][product_id]['count'];
      }
    } else {
      return 0;
    }
  }

  serveLeakPocketCount(product_id) {
    if (this.sales['sales'].hasOwnProperty(product_id)) {
      const leak_percentage = this.sales['leak_percentage'];
      const product_count = this.sales['sales'][product_id]['count'];
      const leak_count = (leak_percentage / 100) * product_count;
      console.log(leak_count);
      return parseInt(String(leak_count), 10);
    } else {
      return 0;
    }
  }

  serveProductCountLitre(product_id) {
    if (this.sales['sales'].hasOwnProperty(product_id)) {
      return this.sales['sales'][product_id]['litre'];
    } else {
      return 0;
    }
  }

  ngOnDestroy() {
    console.log('ng destroy');
    this.is_sales_data_available = false;
    this.sales = {};
  }

}
